import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { prettyDate } from "@/lib/studio";
import { api, apiError } from "@/lib/api";

export function useClosures(onChange) {
  const [closures, setClosures] = useState([]);

  const load = useCallback(() => {
    api.get("/closures").then((r) => setClosures(r.data)).catch((e) => toast.error(apiError(e)));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const add = async (date, reason) => {
    try {
      const { data } = await api.post("/admin/closures", { date, reason });
      toast.success(`${prettyDate(date)} closed`);
      if (data.affected_bookings > 0) {
        toast.warning(`${data.affected_bookings} existing booking(s) on this day — cancel them from the Bookings tab.`);
      }
      load();
      onChange?.();
      return true;
    } catch (err) {
      toast.error(apiError(err));
      return false;
    }
  };

  const remove = async (id) => {
    try {
      await api.delete(`/admin/closures/${id}`);
      toast.success("Day reopened");
      load();
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  return { closures, add, remove };
}
